import { Method } from '@inertiajs/inertia'
import { InertiaLinkProps, Link } from '@inertiajs/inertia-react'
import { EditMenuContext } from 'app/fragments/TaskCard'
import React, { useContext, useState } from 'react'
import route from 'ziggy-js'
import usePageProps from '../hooks/usePageProps'
import Icon from '../Icon'
import { UserType } from '../Types/UserType'

interface Props { }

interface MenuItemProps extends InertiaLinkProps {
    icon: string
    activeRoute: string
    can?: string
    
}

function MenuItem({ href, icon, activeRoute, can, ...rest }: MenuItemProps) {

    let active = route().current()?.startsWith(activeRoute);
    const { user } = usePageProps<{ user: UserType }>();

    return (
        (!can || user.can?.[can]) 
        ? <Link {...rest} className={` rounded-full p-16px ${active ? 'text-white bg-gray-1C1C1C' : 'text-gray-666666'}`} href={href}><Icon name={icon} /></Link>
        : null
    )
}

const links = [
    { href: route('index'), icon: 'stats', activeRoute: 'index' },
    { href: route('tasks.index'), icon: 'tasks', activeRoute: 'tasks' },
    { href: route('projects.index'), icon: 'projects', activeRoute: 'projects' },
    { href: route('team.index'), icon: 'team', activeRoute: 'team', can: 'manage team' },
    { href: route('logout'), icon: 'logout', activeRoute: 'logout', method: Method.POST, as: 'button' },
]

function SideBar(props: Props) {
    const { } = props

    // const [open, setopen] = useState(false);
    const { opened, setOpened } = useContext(EditMenuContext);
    console.log(opened);

    return (
        <div className={`w-100px flex flex-col items-center justify-start py-45px pb-70px border-r border-white/16 
        mob:absolute mob:top-0 mob:left-0 mob:transition-all mob:z-99999 mob:h-full mob:bg-black/50 mob:backdrop-blur-md
        ${opened?.type == 'sidemenu' ? 'mob:translate-x-0' : 'mob:-translate-x-full'} `}
        >
            <Link href={route('index')}><Icon className="text-white" name="logo" /></Link>
            <div className='grow flex items-center justify-center'>
                <div className='flex flex-col text-white p-15px gap-16px '>
                    {
                        links.map(l =>
                            <MenuItem {...l} />
                        )
                    }
                    {/* <Link href={route('index')}>Dashboard</Link>
                    <Link href={route('tasks.index')}>Tasks</Link>
                    <Link href={route('projects.index')}>Projects</Link>
                    <Link className='text-left' method={Method.POST} as="button" href={route('logout')} >Logout</Link> */}
                </div>
            </div>
        </div>
    )
}

export default SideBar
